import React, { ReactNode } from 'react';
import Loading from './Loading';
import { useLoader } from './hooks';

interface Props {
  children?: ReactNode;
}

const Loader = ({ children }: Props) => {
  const { loading } = useLoader();

  return (
    <>
      <Loading loading={loading} />
      {children}
    </>
  );
};

export default Loader;
